import * as yup from 'yup';

const validationSchema = (intl) =>
  yup.object({
    name: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.name.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    placeId: yup.string('').required(intl.formatMessage({ id: 'validation.required' })),
    notes: yup.string().nullable(),
  });

export default validationSchema;
